<template>
  <button
      class="btn btn-primary"
      @click.prevent="previewPrivateCoachingBill">
    {{ $t('general.print') }}
  </button>
</template>

<script setup>
import { downloadFile } from '@/shared/functions';
import { defineProps, toRefs } from 'vue';

const props = defineProps({
  coachId: {
    type: Number,
    require: true,
  },
  filters: {
    type: Object,
    required: true,
  },
});

const { filters, coachId } = toRefs(props);

const previewPrivateCoachingBill = () => {
  downloadFile(
      `/coach-billing/private-coaching/preview-bill/${coachId.value}`,
      undefined, filters.value,
  );
};


</script>
